import { gql } from '@apollo/client';

export const GET_NAVIGATION_LINK_QUERY = gql`
  query getNavigationLinkQuery($group_id: String, $company_id: String, $id: String) {
    navigation_links(group_id: $group_id, company_id: $company_id, id: $id) {
      id
      name
      deleted
      url
      type
      metadata
      company {
        id
        name
        group {
          id
          name
        }
      }
    }
  }
`;
